import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ModalController } from "@ionic/angular";
import { SmsNotificationLotteryResultResponse } from "src/app/model/SmsNotificationLotteryResultResponse";
import { SMSNotificationLotteryResultService } from "src/app/services/sms-notif-lot-result.service";

@Component({
  selector: "app-secure-sms-notif-lot-result-list",
  templateUrl: "./sms-notif-lot-result-list.component.html",
  styleUrls: ["./sms-notif-lot-result-list.component.scss"],
})
export class SMSNotificationLotteryResultListComponent implements OnInit, AfterViewInit {
  list : Page<SmsNotificationLotteryResultResponse>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<SmsNotificationLotteryResultResponse> = new MatTableDataSource();
  displayedColumns: string[] = [
    "id",
    "lottery",
    "winnerCount",
    "createdOn",
    "status",
    "action",    
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  
  statuses: string[] = ["PENDING", "SCHEDULED", "COMPLETED"];

  constructor(
    private smsNotificationLotteryResultService: SMSNotificationLotteryResultService,
    private _snackBar: MatSnackBar, private modalCtrl: ModalController
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      status: new FormControl("PENDING",),
      filterText: new FormControl(null, [Validators.minLength(3)]),
    });
  }

  onSearch() {
    if (this.filterForm.valid) {
      this.onDataLoad();
    }
    else {
      if(this.filterForm.value?.filterText && this.filterForm.value?.filterText.length < 3) {
        this._snackBar.open("Please enter Minimum (3 chars) for Filter", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
        this.isSearchDisabled = false;
      }
    }
  }

  resetFilter() {
    this.ngOnInit();
  }

  removeSearchedListAndSavedFilter() {
    this.list = null;
    this.dataSource = null;
    this.paginator.pageIndex = 0;
    this.paginator.length = 0; 
  }
  
  onDataLoad() {
    this.isLoading = true;
    this.isSearchDisabled = true;
    this.smsNotificationLotteryResultService.fetchList(
      this.currentPage,
      this.pageSize,
      this.filterForm.value?.status,
      this.filterForm.value?.filterText
    ).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          console.log(data);
          this.list = data.data;
          this.dataSource = new MatTableDataSource(data.data.content);
          
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = data.data.totalElements;
          });
    
          this.isSearchDisabled = false;
        }
        else {
          this.smsNotificationLotteryResultService.errorToast(data.errorMessage);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
        this.isSearchDisabled = false;
        this.smsNotificationLotteryResultService.errorToast(error?.error?.errorMessage||error?.errorMessage);
      }
    );
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onDataLoad();
  }
  
  viewClassForStatus(status: string) {
    if(status === 'PENDING') {
        return 'bg-blue-400';
    }
    else if(["COMPLETED"].indexOf(status) >= 0) {
        return 'bg-green-400';
    }
    else if(["SCHEDULED"].indexOf(status) >= 0) {
        return 'bg-pink-600';
    }
    else {
        return '';
    }
  }

  sendSMS(key: number) {
    this.smsNotificationLotteryResultService.sendSMS(key).subscribe((data) => {
      if(data.status === 'SUCCESS') {
        this.smsNotificationLotteryResultService.successToast("SMS scheduled successfully.");
        this.onDataLoad();
      }
      else {
        this.smsNotificationLotteryResultService.errorToast(data.errorMessage);       
      }
    }, (error) => {
      console.log(error);
      this.isLoading = false;
      this.isSearchDisabled = false;
      this.smsNotificationLotteryResultService.errorToast(error?.error?.errorMessage||error?.errorMessage);
    });
  }

}